import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import {
  clearChunkReloadFlag,
  isChunkLoadError,
  tryReloadOnceForStaleChunks,
} from "../lib/chunk-load-recovery";

function errorMessage(error: unknown): string {
  if (isRouteErrorResponse(error)) {
    return error.statusText || error.data?.toString?.() || `HTTP ${error.status}`;
  }
  if (error instanceof Error) return error.message;
  return String(error ?? "unknown error");
}

export function RouteErrorFallback() {
  const error = useRouteError();
  const message = errorMessage(error);
  const chunkStale = isChunkLoadError(error) || isChunkLoadError({ message });

  useEffect(() => {
    if (chunkStale) {
      tryReloadOnceForStaleChunks();
    }
  }, [chunkStale]);

  return (
    <div
      dir="rtl"
      className="godo-app-bg flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center"
    >
      <h1 className="text-lg font-bold text-godo-primary">تعذّر فتح هذه الشاشة</h1>
      {chunkStale ? (
        <p className="max-w-md text-sm text-slate-600">
          تم نشر نسخة جديدة من البرنامج والمتصفح يحاول تحميل ملف قديم. جاري التحديث تلقائياً…
          إن لم يتغير شيء، اضغط الزر أدناه (Ctrl+F5).
        </p>
      ) : (
        <p className="max-w-md text-sm text-slate-600">
          حدث خطأ أثناء تحميل الصفحة. جرّب تحديث الصفحة أو العودة للوحة التحكم.
        </p>
      )}
      <p className="max-w-lg break-all text-xs text-red-700" dir="ltr">
        {message}
      </p>
      <div className="flex flex-wrap justify-center gap-2">
        <button
          type="button"
          className="godo-btn-primary w-auto px-6"
          onClick={() => {
            clearChunkReloadFlag();
            window.location.reload();
          }}
        >
          تحديث كامل (Ctrl+F5)
        </button>
        <a href="/dashboard" className="godo-btn-ghost">
          لوحة التحكم
        </a>
      </div>
    </div>
  );
}
